import script from "./SidebarOverrides.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarOverrides.vue?vue&type=script&setup=true&lang=js"

import "./SidebarOverrides.vue?vue&type=style&index=0&id=0557c1ed&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0557c1ed"]])

export default __exports__